import React, { useEffect, useState } from "react";
import { Col, Input, DatePicker, InputNumber } from 'antd';

// Array of filter options
const typeOfFilter = [
    { label: 'Number', value: 'Number' },
    { label: 'Text', value: 'Text' },
    { label: 'Date', value: 'Date' },
];

const useAntFilter = (props) => {
    // State variables
    const [searchText, setSearchText] = useState('');
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filterOpen, setFilterOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [type, setType] = useState('');
    const [sendStatus, setSendStatus] = useState(false);

    // Event handlers 
    const onChangeSerchText = (e) => { setSearchText(e.target.value) };
    const onChangeSerchMin = (value) => { setMin(value) };
    const onChangeSerchMax = (value) => { setMax(value) };
    const onChangeSerchStartDate = (date, dateSting) => { setStartDate(dateSting) };
    const onChangeSerchEndDate = (date, dateSting) => { setEndDate(dateSting) };
    const handleOpenChange = (newOpen) => { setFilterOpen(newOpen); };
    const onChangeType = ({ target: { value } }) => { setType(value); };

    // Array of filter options excluding selected items
    const filteredOptions = props?.fields?.filter((o) => !selectedItems.includes(o));

    // Function to apply filters
    const apply = () => {
        if (type === 'Text') {
            props.getData({ filterText: searchText }, selectedItems)
        } else if (type === 'Number') {
            props.getData({ minNbr: min, maxNbr: max }, selectedItems)
        } else if (type === 'Date') {
            props.getData({ fromDate: startDate, toDate: endDate }, selectedItems)
        }
        setSendStatus(!sendStatus)
    };

    // Function to reset all filters
    const reset = () => {
        setSelectedItems([]);
        setType('');
        setSearchText('');
        setMax(0);
        setMin(0);
        props.getData();
        setSendStatus(!sendStatus);
    };

    // Function to update filter status
    const updateFilterStatus = () => {
        if (props?.getFilterStatus) {
            props.getFilterStatus(
                selectedItems.length > 0 &&
                type.length > 0 &&
                (min > 0 || max > 0 || searchText.length > 0 || startDate.length > 0 || endDate.length > 0)
            );
        }
    };

    useEffect(() => {
        // This will be executed after the component re-renders due to state updates
        updateFilterStatus();
    }, [sendStatus]);

    // Function to render filter options based on the selected type
    const renderFilterOptions = () => {
        switch (type) {
            case 'Number':
                return (
                    <>
                        <Col span={12}><InputNumber addonBefore='min' min={0} max={max > 0 ? max - 1 : false} defaultValue={0} onChange={onChangeSerchMin} style={{ width: "100%" }} /></Col>
                        <Col span={12}><InputNumber addonBefore='max' min={min > 0 ? min + 1 : 0} defaultValue={0} onChange={onChangeSerchMax} style={{ width: "100%" }} /></Col>
                    </>
                );
            case 'Text':
                return (
                    <Col span={24}><Input placeholder='text' type='text' value={searchText} onChange={onChangeSerchText} /></Col>
                );
            case 'Date':
                return (
                    <>
                        <Col span={12}><DatePicker placeholder="start date" onChange={onChangeSerchStartDate} style={{ width: "100%" }} /></Col>
                        <Col span={12}><DatePicker placeholder="end date" onChange={onChangeSerchEndDate} style={{ width: "100%" }} /></Col>
                    </>
                );
            default:
                return null;
        }
    };

    return {
        filterOpen,
        handleOpenChange,
        renderFilterOptions,
        onChangeType,
        filteredOptions,
        setSelectedItems,
        selectedItems,
        typeOfFilter,
        type,
        apply,
        reset,
    };
};

export default useAntFilter;
